import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  gridMargin: {
    marginRight: 100,
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  icon: {
    marginRight: theme.spacing(1)
  },

  message: {
    width: '100%',
    position: 'absolute',
    zIndex: 999,
    left: '50%',
    transform: 'translateX(22%)'
  },

  summaryCard: {
    borderRadius: 12,
    padding: theme.spacing(2.5),
  },

  summaryTitle: {
    color: '#6B778C',
    fontWeight: 600,
  },

  summaryIconBlue: {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E6F3FC',
    color: '#1695D1',
  },

  summaryIconGreen: {
    width: 38,
    height: 38,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EAF7F2',
    color: '#2EB67D',
  },

  summaryIconSize: {
    fontSize: 18,
  },

  summaryRatio: {
    display: 'flex',
    alignItems: 'baseline',
    marginTop: theme.spacing(1.5),
    gap: theme.spacing(0.8),
  },

  summaryNumberBlue: {
    color: '#1695D1',
    fontWeight: 700,
    lineHeight: 1,
  },

  summaryNumberGreen: {
    color: '#2EB67D',
    fontWeight: 700,
    lineHeight: 1,
  },

  summaryTotal: {
    color: '#6B778C',
    lineHeight: 1,
  },

  summaryMetaRow: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  summaryMetaText: {
    color: '#6B778C',
    fontWeight: 500,
  },

  progressTrack: {
    width: '100%',
    height: 8,
    borderRadius: 999,
    backgroundColor: '#E5EAF0',
    overflow: 'hidden',
  },

  progressBarBlue: {
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#1695D1',
    transition: 'width 0.3s ease',
  },

  progressBarGreen: {
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#2EB67D',
    transition: 'width 0.3s ease',
  },
}));
